export default [
    {
        path: '/tms/redirect/:path*',
        component: () => import('./tms/views/redirect/index')
    },
    {
        path: '/tms/index',
        name: 'tmsIndex',
        meta: { title: 'tms.route.index', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/Index')
    },
    {
        path: '/tms/appointment',
        name: 'appointment',
        meta: { title: 'tms.route.appointment', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/appointment/Index')
    },
    {
        path: '/tms/dispatch',
        name: 'dispatch',
        meta: { title: 'tms.route.dispatch', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/dispatchManage/Index')
    },
    {
        path: '/tms/dispatch-order',
        name: 'tmsDispatchOrder',
        meta: { title: 'tms.route.dispatchOrder', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/dispatchOrder/Index')
    },
    {
        path: '/tms/carrier-manage',
        name: 'carrierManage',
        meta: { title: 'tms.route.carrierManage', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/carrierManage/Index')
    },
    {
        path: '/tms/receipt-manage',
        name: 'receiptManage',
        meta: { title: 'tms.route.receiptManage', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/receiptManage/Index')
    },
    {
        path: '/tms/equipment',
        name: 'equipment',
        meta: { title: 'tms.route.equipment', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/equipment/Index')
    },
    {
        path: '/tms/passage',
        name: 'passage',
        meta: { title: 'tms.route.passage', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/passage/Index')
    },
    {
        path: '/tms/order-panel',
        name: 'orderPanel',
        meta: { title: 'tms.route.orderPanel', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/orderPanel/Index')
    },
    {
        path: '/tms/revocation-carrier-history',
        name: 'revocationCarrierHistory',
        meta: { title: 'tms.route.revocationCarrierHistory', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./tms/views/revocationCarrierHistory/Index')
    }
];
